import React, { useEffect, useRef, useState } from 'react';

function OdoDigit({ d }) {
  const n = Math.max(0, Math.min(9, d));
  return (
    <span className="odo-d">
      <span className="odo-roll" style={{ '--n': n }}>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((x) => (
          <span key={x}>{x}</span>
        ))}
      </span>
    </span>
  );
}

export default function Odometer({ value, className = '' }) {
  const str = String(value);
  return (
    <span className={`odo ${className}`}>
      {[...str].map((ch, i) => /\d/.test(ch)
        ? <OdoDigit key={i} d={parseInt(ch, 10)} />
        : <span key={i} className="odo-sep">{ch}</span>
      )}
    </span>
  );
}

/* RollNumber — wraps Odometer so the target rolls from 0 the first time
   the element scrolls into view. For revealing static stats inside prose. */
export function RollNumber({ value, threshold = 0.4 }) {
  const [v, setV] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') { setV(value); return; }
    let done = false;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !done) {
          done = true;
          /* defer a tick so the CSS transition fires */
          requestAnimationFrame(() => setV(value));
          obs.disconnect();
        }
      });
    }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, threshold]);
  return <span ref={ref}><Odometer value={v} /></span>;
}
